export default "__VITE_ASSET__BpDbSxUv__"